var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"assembly"},[_c('Header'),_c('div',{staticClass:"assembly-content",class:[
      _vm.$route.path.split('/')[1] === 'user' ? 'use-lanhu-bg-color' : '',
    ]},[_c('Bread'),_c('keep-alive',[_c('router-view',{key:_vm.$route.fullPath})],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }